
import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const SystemsAutomationConsulting = () => {
  return (
    <div className="font-['Raleway',sans-serif] bg-white text-gray-900 overflow-x-hidden pt-[90px]">
      
      <Navbar />

      
      <section className="relative min-h-[300px] flex items-center justify-center overflow-hidden">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url('https://images.unsplash.com/photo-1551434678-e076c223a692?w=1920&q=80')`,
          }}
        />
        <div className="absolute inset-0 bg-[#19354a]/90" />
        
        <div className="relative z-10 text-center px-6">
          <motion.h1 
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-8"
          >
            Healthcare Systems, Automation & Consulting
          </motion.h1>
          
          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="flex items-center justify-center gap-4 flex-wrap"
          >
            <Link 
              to="/" 
              className="px-8 py-3 bg-[#39a5d3] text-white rounded-full font-semibold hover:bg-[#2a8db8] transition-all"
            >
              Home
            </Link>
            <span className="text-white text-2xl">|</span>
            <Link 
              to="/services" 
              className="px-8 py-3 bg-[#39a5d3] text-white rounded-full font-semibold hover:bg-[#2a8db8] transition-all"
            >
              Services
            </Link>
            <span className="text-white text-2xl">|</span>
            <span className="px-8 py-3 bg-[#39a5d3] text-white rounded-full font-semibold">
              Systems & Automation
            </span>
          </motion.div>
        </div>
      </section>

      {/*  CONTENT SECTION  */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            
            {/* Left - Image & Tagline */}
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              {/* Tag */}
              <span className="inline-block px-4 py-2 border border-gray-300 rounded-md text-gray-600 text-sm mb-6">
                HEALTHCARE AUTOMATION
              </span>
              
              {/* Tagline */}
              <h2 className="text-2xl lg:text-3xl font-bold text-gray-900 mb-8">
                The Leading <span className="text-[#19354a]">Healthcare Systems & AutomationPartner</span> To Streamline Your Medical Practice Operations!
              </h2>
              
              <img 
                src="/images/creative4.png" 
                alt="Healthcare Systems & Automation"
                className="w-full max-w-[450px] h-auto mx-auto"
              />
            </motion.div>

            {/* Right - Content */}
            <div>
              <motion.p 
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5 }}
                className="text-gray-700 leading-relaxed mb-6"
              >
                In today's fast-paced healthcare environment, efficiency is everything. Manual processes and disconnected systems can cost your medical practice valuable time and resources. At Docmize, we help healthcare providers automate their workflows, integrate their medical tools, and build HIPAA-compliant systems that scale.
              </motion.p>
              
              <motion.p 
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.1 }}
                className="text-gray-700 leading-relaxed mb-6"
              >
                From <strong className="text-[#19354a]">EHR/EMR integration and patient communication automation</strong> to advanced healthcare analytics dashboards and appointment reminder systems, we create HIPAA-compliant solutions that work for your medical practice 24/7. Our team specializes in connecting the dots between your healthcare tools and processes, eliminating redundancy and maximizing patient care efficiency.
              </motion.p>

              <motion.p 
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.2 }}
                className="text-gray-700 leading-relaxed mb-6"
              >
                Whether you need medical virtual assistants to handle administrative operations, security monitoring for protected health information, or strategic healthcare consulting to guide your practice growth, Docmize has the expertise to deliver results.
              </motion.p>

              <motion.p 
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.3 }}
                className="text-gray-900 font-semibold leading-relaxed mb-8"
              >
                Work smarter, not harder. Partner with Docmize and let's automate your practice success!
              </motion.p>

              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.4 }}
              >
                <Link 
                  to="/contact" 
                  className="inline-block px-8 py-4 bg-[#19354a] text-white rounded-lg font-semibold hover:bg-[#0f2133] transition-all"
                >
                  GET A QUOTE
                </Link>
              </motion.div>
            </div>

          </div>
        </div>
      </section>

      {/* WHY CHOOSE US - BLUE SECTION */}
      <section className="relative py-20 overflow-hidden">
        <div 
          className="absolute inset-0"
          style={{
            background: 'linear-gradient(135deg, #0f1c3f 0%, #1a2d5e 50%, #152349 100%)'
          }}
        />
        
        <div className="absolute inset-0 overflow-hidden">
          <div 
            className="absolute inset-0"
            style={{
              backgroundImage: `repeating-linear-gradient(
                45deg,
                transparent,
                transparent 50px,
                rgba(59, 130, 246, 0.1) 50px,
                rgba(59, 130, 246, 0.1) 52px
              )`
            }}
          />
          <div className="absolute top-0 left-[20%] w-[2px] h-full bg-gradient-to-b from-transparent via-blue-500/20 to-transparent transform rotate-[30deg] origin-top"></div>
          <div className="absolute top-0 left-[40%] w-[2px] h-full bg-gradient-to-b from-transparent via-blue-400/30 to-transparent transform rotate-[30deg] origin-top"></div>
          <div className="absolute top-0 left-[60%] w-[3px] h-full bg-gradient-to-b from-transparent via-blue-500/20 to-transparent transform rotate-[30deg] origin-top"></div>
          <div className="absolute top-0 left-[80%] w-[2px] h-full bg-gradient-to-b from-transparent via-blue-400/15 to-transparent transform rotate-[30deg] origin-top"></div>
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-6">
          
          <motion.div 
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-center mb-12"
          >
            <h2 className="text-3xl lg:text-4xl xl:text-5xl font-bold text-white mb-4">
              Why Choose Our Healthcare Automation Services?
            </h2>
            <p className="text-white/70 text-lg">
              Here's why medical practices trust us with their healthcare systems:
            </p>
          </motion.div>

          <div className="grid md:grid-cols-2 gap-x-16 gap-y-8 max-w-5xl mx-auto">
            
            <div className="space-y-8">
              <motion.div 
                initial={{ opacity: 0, x: -30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.1 }}
                className="flex items-start gap-4"
              >
                <span className="text-[#39a5d3] text-2xl font-bold">»</span>
                <p className="text-white text-lg">HIPAA-compliant analytics with custom healthcare dashboards</p>
              </motion.div>

              <motion.div 
                initial={{ opacity: 0, x: -30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.2 }}
                className="flex items-start gap-4"
              >
                <span className="text-[#39a5d3] text-2xl font-bold">»</span>
                <p className="text-white text-lg">EHR/EMR integration and workflow automation for medical practices</p>
              </motion.div>

              <motion.div 
                initial={{ opacity: 0, x: -30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.3 }}
                className="flex items-start gap-4"
              >
                <span className="text-[#39a5d3] text-2xl font-bold">»</span>
                <p className="text-white text-lg">Patient communication and appointment reminder automation</p>
              </motion.div>

              <motion.div 
                initial={{ opacity: 0, x: -30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.4 }}
                className="flex items-start gap-4"
              >
                <span className="text-[#39a5d3] text-2xl font-bold">»</span>
                <p className="text-white text-lg">Dedicated medical virtual assistants for administrative tasks</p>
              </motion.div>
            </div>

            <div className="space-y-8">
              <motion.div 
                initial={{ opacity: 0, x: 30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.1 }}
                className="flex items-start gap-4"
              >
                <span className="text-[#39a5d3] text-2xl font-bold">»</span>
                <p className="text-white text-lg">Professional patient support handling and inquiry management</p>
              </motion.div>

              <motion.div 
                initial={{ opacity: 0, x: 30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.2 }}
                className="flex items-start gap-4"
              >
                <span className="text-[#39a5d3] text-2xl font-bold">»</span>
                <p className="text-white text-lg">Healthcare data security monitoring and threat protection</p>
              </motion.div>

              <motion.div 
                initial={{ opacity: 0, x: 30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.3 }}
                className="flex items-start gap-4"
              >
                <span className="text-[#39a5d3] text-2xl font-bold">»</span>
                <p className="text-white text-lg">Automated backup solutions and HIPAA compliance support</p>
              </motion.div>

              <motion.div 
                initial={{ opacity: 0, x: 30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.4 }}
                className="flex items-start gap-4"
              >
                <span className="text-[#39a5d3] text-2xl font-bold">»</span>
                <p className="text-white text-lg">Strategic healthcare consulting for practice growth and efficiency</p>
              </motion.div>
            </div>

          </div>
        </div>
      </section>

      {/* OUR SERVICES SECTION  */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          
          <motion.div 
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-center mb-12"
          >
            <h2 className="text-3xl lg:text-4xl xl:text-5xl font-bold text-[#19354a] mb-4">
              Our Healthcare Systems & Automation Services
            </h2>
            <p className="text-gray-600 max-w-3xl mx-auto">
              Comprehensive solutions to automate and scale your medical practice operations
            </p>
          </motion.div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            
            {/* Service 1 */}
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.1 }}
              whileHover={{ y: -10 }}
              className="bg-white rounded-2xl p-6 border-2 border-[#19354a] hover:shadow-xl transition-all duration-300"
            >
              <div className="w-14 h-14 bg-[#19354a] rounded-xl flex items-center justify-center mb-4">
                <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                </svg>
              </div>
              <h3 className="text-lg font-bold text-[#19354a] mb-3">Healthcare Analytics</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                HIPAA-compliant dashboards for patient metrics and practice performance.
              </p>
            </motion.div>

            {/* Service 2 */}
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.2 }}
              whileHover={{ y: -10 }}
              className="bg-white rounded-2xl p-6 border-2 border-[#19354a] hover:shadow-xl transition-all duration-300"
            >
              <div className="w-14 h-14 bg-[#19354a] rounded-xl flex items-center justify-center mb-4">
                <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M4 7v10c0 2.21 3.582 4 8 4s8-1.79 8-4V7M4 7c0 2.21 3.582 4 8 4s8-1.79 8-4M4 7c0-2.21 3.582-4 8-4s8 1.79 8 4m0 5c0 2.21-3.582 4-8 4s-8-1.79-8-4" />
                </svg>
              </div>
              <h3 className="text-lg font-bold text-[#19354a] mb-3">EHR/EMR Integration</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                Seamless integration with electronic health record systems.
              </p>
            </motion.div>

            {/* Service 3 */}
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.3 }}
              whileHover={{ y: -10 }}
              className="bg-white rounded-2xl p-6 border-2 border-[#19354a] hover:shadow-xl transition-all duration-300"
            >
              <div className="w-14 h-14 bg-[#19354a] rounded-xl flex items-center justify-center mb-4">
                <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
              </div>
              <h3 className="text-lg font-bold text-[#19354a] mb-3">Patient Communication</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                Automated appointment reminders and patient follow-up systems.
              </p>
            </motion.div>

            {/* Service 4 */}
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.4 }}
              whileHover={{ y: -10 }}
              className="bg-white rounded-2xl p-6 border-2 border-[#19354a] hover:shadow-xl transition-all duration-300"
            >
              <div className="w-14 h-14 bg-[#19354a] rounded-xl flex items-center justify-center mb-4">
                <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
              </div>
              <h3 className="text-lg font-bold text-[#19354a] mb-3">Medical Virtual Assistants</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                Trained VAs for medical admin, scheduling, and back-office tasks.
              </p>
            </motion.div>

            {/* Service 5 */}
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.5 }}
              whileHover={{ y: -10 }}
              className="bg-white rounded-2xl p-6 border-2 border-[#19354a] hover:shadow-xl transition-all duration-300"
            >
              <div className="w-14 h-14 bg-[#19354a] rounded-xl flex items-center justify-center mb-4">
                <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.192l-3.536 3.536M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v2m0 4h.01" />
                </svg>
              </div>
              <h3 className="text-lg font-bold text-[#19354a] mb-3">Patient Support Systems</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                Professional patient inquiry handling and ticket management.
              </p>
            </motion.div>

            {/* Service 6 */}
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.6 }}
              whileHover={{ y: -10 }}
              className="bg-white rounded-2xl p-6 border-2 border-[#19354a] hover:shadow-xl transition-all duration-300"
            >
              <div className="w-14 h-14 bg-[#19354a] rounded-xl flex items-center justify-center mb-4">
                <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                </svg>
              </div>
              <h3 className="text-lg font-bold text-[#19354a] mb-3">Healthcare Data Security</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                HIPAA-compliant security monitoring and threat protection.
              </p>
            </motion.div>

            {/* Service 7 */}
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.7 }}
              whileHover={{ y: -10 }}
              className="bg-white rounded-2xl p-6 border-2 border-[#19354a] hover:shadow-xl transition-all duration-300"
            >
              <div className="w-14 h-14 bg-[#19354a] rounded-xl flex items-center justify-center mb-4">
                <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M4 7v10c0 2 1 3 3 3h10c2 0 3-1 3-3V7c0-2-1-3-3-3H7C5 4 4 5 4 7z" />
                  <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4" />
                </svg>
              </div>
              <h3 className="text-lg font-bold text-[#19354a] mb-3">HIPAA Compliance</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                Automated backups and compliance support for protected health data.
              </p>
            </motion.div>

            {/* Service 8 */}
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.8 }}
              whileHover={{ y: -10 }}
              className="bg-white rounded-2xl p-6 border-2 border-[#19354a] hover:shadow-xl transition-all duration-300"
            >
              <div className="w-14 h-14 bg-[#19354a] rounded-xl flex items-center justify-center mb-4">
                <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
                </svg>
              </div>
              <h3 className="text-lg font-bold text-[#19354a] mb-3">Healthcare Consulting</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                Expert medical practice consulting for growth and efficiency.
              </p>
            </motion.div>

          </div>
        </div>
      </section>

      {/*  ENTRUST US SECTION  */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            
            {/* Left - Content */}
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              <h2 className="text-3xl lg:text-4xl xl:text-5xl font-bold text-[#19354a] mb-2">
                Entrust us to Automate
              </h2>
              <h2 className="text-3xl lg:text-4xl xl:text-5xl font-bold text-[#19354a] mb-4">
                Your Medical Practice Systems,
              </h2>
              <h3 className="text-2xl lg:text-3xl font-bold text-[#19354a] mb-2">
                Eliminate Administrative Burdens
              </h3>
              <h3 className="text-2xl lg:text-3xl font-bold text-[#19354a] mb-8">
                and Focus on Patient Care.
              </h3>

              {/* Checklist Items */}
              <div className="space-y-5">
                <motion.div 
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.4, delay: 0.1 }}
                  className="flex items-start gap-4"
                >
                  <div className="w-6 h-6 bg-[#E85A2C] rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" strokeWidth={3} viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                    </svg>
                  </div>
                  <p className="text-gray-700 leading-relaxed">
                    Set up HIPAA-compliant systems that automate patient scheduling, follow-ups, and medical records management.
                  </p>
                </motion.div>

                <motion.div 
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.4, delay: 0.2 }}
                  className="flex items-start gap-4"
                >
                  <div className="w-6 h-6 bg-[#E85A2C] rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" strokeWidth={3} viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                    </svg>
                  </div>
                  <p className="text-gray-700 leading-relaxed">
                    Build custom healthcare dashboards that give you real-time insights into patient metrics and practice performance.
                  </p>
                </motion.div>

                <motion.div 
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.4, delay: 0.3 }}
                  className="flex items-start gap-4"
                >
                  <div className="w-6 h-6 bg-[#E85A2C] rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" strokeWidth={3} viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                    </svg>
                  </div>
                  <p className="text-gray-700 leading-relaxed">
                    Create patient communication workflows that send automated reminders and improve appointment show rates.
                  </p>
                </motion.div>

                <motion.div 
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.4, delay: 0.4 }}
                  className="flex items-start gap-4"
                >
                  <div className="w-6 h-6 bg-[#E85A2C] rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" strokeWidth={3} viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                    </svg>
                  </div>
                  <p className="text-gray-700 leading-relaxed">
                    Provide dedicated medical virtual assistants to handle administrative tasks so you can focus on patient care.
                  </p>
                </motion.div>
              </div>
            </motion.div>

            {/* Right - Image */}
            <motion.div
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="flex justify-center"
            >
              <img 
                src="/images/creative5.png" 
                alt="Automate Your Medical Practice"
                className="w-full max-w-[500px] h-auto"
              />
            </motion.div>

          </div>
        </div>
      </section>

      {/*  OUR AUTOMATION STRATEGY SECTION  */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          
          {/* Section Header */}
          <motion.div 
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-center mb-12"
          >
            <h2 className="text-3xl lg:text-4xl xl:text-5xl font-bold text-[#19354a] mb-4">
              OUR HEALTHCARE SYSTEMS & AUTOMATION
            </h2>
            <h3 className="text-3xl lg:text-4xl xl:text-5xl font-bold text-[#19354a]">
              STRATEGY
            </h3>
          </motion.div>

          {/* Image Left - Content Right */}
          <div className="grid lg:grid-cols-2 gap-0">
            {/* Left - Image */}
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              className="bg-gray-100"
            >
              <img 
                src="/images/creative6.png" 
                alt="Healthcare Automation Strategy"
                className="w-full h-full min-h-[400px] object-cover"
              />
            </motion.div>

            {/* Right - Content with Yellow Background */}
            <motion.div
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="bg-[#fef9e7] p-8 lg:p-12 flex flex-col justify-center"
            >
              <div className="grid grid-cols-2 gap-x-8 gap-y-6">
                <motion.div 
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.4, delay: 0.3 }}
                  className="flex items-start gap-3"
                >
                  <span className="text-[#19354a] text-xl font-bold">»</span>
                  <p className="text-gray-800 font-medium">Practice Analysis</p>
                </motion.div>

                <motion.div 
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.4, delay: 0.35 }}
                  className="flex items-start gap-3"
                >
                  <span className="text-[#19354a] text-xl font-bold">»</span>
                  <p className="text-gray-800 font-medium">Workflow Identification</p>
                </motion.div>

                <motion.div 
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.4, delay: 0.4 }}
                  className="flex items-start gap-3"
                >
                  <span className="text-[#19354a] text-xl font-bold">»</span>
                  <p className="text-gray-800 font-medium">HIPAA-Compliant Strategy</p>
                </motion.div>

                <motion.div 
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.4, delay: 0.45 }}
                  className="flex items-start gap-3"
                >
                  <span className="text-[#19354a] text-xl font-bold">»</span>
                  <p className="text-gray-800 font-medium">Secure Implementation</p>
                </motion.div>

                <motion.div 
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.4, delay: 0.5 }}
                  className="flex items-start gap-3"
                >
                  <span className="text-[#19354a] text-xl font-bold">»</span>
                  <p className="text-gray-800 font-medium">Performance Monitoring</p>
                </motion.div>

                <motion.div 
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.4, delay: 0.55 }}
                  className="flex items-start gap-3"
                >
                  <span className="text-[#19354a] text-xl font-bold">»</span>
                  <p className="text-gray-800 font-medium">Continuous Optimization</p>
                </motion.div>
              </div>
            </motion.div>
          </div>

        </div>
      </section>

      {/*  WHY CHOOSE US SECTION  */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          
          {/* Section Header */}
          <motion.div 
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-center mb-12"
          >
            <h2 className="text-3xl lg:text-4xl xl:text-5xl font-bold text-[#19354a]">
              Why Choose Us for Healthcare Automation?
            </h2>
          </motion.div>

          {/* Image Left - Content Right */}
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            
            {/* Left - Image */}
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              <img 
                src="/images/creative7.png" 
                alt="Why Choose Docmize"
                className="w-full max-w-[500px] h-auto mx-auto"
              />
            </motion.div>

            {/* Right - Content */}
            <motion.div
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              <p className="text-gray-700 leading-relaxed mb-6">
                To succeed in modern healthcare, you need intelligently designed and automated systems that maintain HIPAA compliance. Systems that don't lose efficiency under pressure; they must rapidly adapt to your medical practice needs and provide simple access to manage patient data securely.
              </p>

              <p className="text-gray-700 leading-relaxed mb-6">
                We at <span className="text-[#19354a] font-semibold">Docmize</span> combine healthcare expertise and cutting-edge technology to deliver HIPAA-compliant solutions that truly matter. Our approach combines medical industry knowledge, security innovation, and a patient-first mindset to deliver real growth for your practice. We ensure your systems are not only efficient but also scalable and compliant.
              </p>

              <p className="text-gray-700 leading-relaxed mb-8">
                From healthcare analytics to patient communication automation, with our <strong>medical practice systems and automation services</strong>, we execute every detail with precision and HIPAA compliance. With our specialized healthcare offerings, we promise measurable results and long-term practice success:
              </p>

              {/* Benefits List */}
              <div className="space-y-4">
                <motion.div 
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.4, delay: 0.3 }}
                  className="flex items-start gap-3"
                >
                  <div className="w-5 h-5 bg-[#19354a] rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <svg className="w-3 h-3 text-white" fill="none" stroke="currentColor" strokeWidth={3} viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                    </svg>
                  </div>
                  <p className="text-gray-700">Custom HIPAA-compliant automation workflows for medical practices</p>
                </motion.div>

                <motion.div 
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.4, delay: 0.35 }}
                  className="flex items-start gap-3"
                >
                  <div className="w-5 h-5 bg-[#19354a] rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <svg className="w-3 h-3 text-white" fill="none" stroke="currentColor" strokeWidth={3} viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                    </svg>
                  </div>
                  <p className="text-gray-700">Seamless EHR/EMR integration with your existing healthcare tools</p>
                </motion.div>

                <motion.div 
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.4, delay: 0.4 }}
                  className="flex items-start gap-3"
                >
                  <div className="w-5 h-5 bg-[#19354a] rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <svg className="w-3 h-3 text-white" fill="none" stroke="currentColor" strokeWidth={3} viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                    </svg>
                  </div>
                  <p className="text-gray-700">24/7 monitoring and support to ensure patient data security</p>
                </motion.div>

                <motion.div 
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.4, delay: 0.45 }}
                  className="flex items-start gap-3"
                >
                  <div className="w-5 h-5 bg-[#19354a] rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <svg className="w-3 h-3 text-white" fill="none" stroke="currentColor" strokeWidth={3} viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                    </svg>
                  </div>
                  <p className="text-gray-700">Scalable healthcare solutions that grow with your practice needs</p>
                </motion.div>
              </div>
            </motion.div>

          </div>
        </div>
      </section>

      {/*  FAQ SECTION  */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          
          {/* Section Header */}
          <motion.div 
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-center mb-12"
          >
            <h2 className="text-3xl lg:text-4xl font-bold text-[#19354a]">
              Frequently Asked Questions about
            </h2>
            <h3 className="text-3xl lg:text-4xl font-bold text-[#19354a]">
              Healthcare Automation Services.
            </h3>
          </motion.div>

          {/* FAQ Content - Image Left, Questions Right */}
          <div className="grid lg:grid-cols-2 gap-12 items-start">
            
            {/* Left - Image */}
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              className="flex justify-center lg:sticky lg:top-24"
            >
              <img 
                src="/images/faq-img.png" 
                alt="FAQ Healthcare Automation"
                className="w-full max-w-[220px] h-auto"
              />
            </motion.div>

            {/* Right - FAQ Items */}
            <div className="space-y-4">
              {[
                {
                  question: "What EHR/EMR systems do you integrate with?",
                  answer: "We work with all major EHR/EMR systems including Epic, Cerner, Allscripts, eClinicalWorks, athenahealth, and more. We can help you integrate your existing system or recommend the best solution for your medical practice needs."
                },
                {
                  question: "How long does healthcare automation implementation take?",
                  answer: "Simple patient communication automations can be set up in a few days, while complex EHR integrations may take 3-6 weeks. We provide a detailed HIPAA-compliant timeline during our initial consultation based on your specific practice requirements."
                },
                {
                  question: "Are your automation solutions HIPAA-compliant?",
                  answer: "Yes! All our healthcare automation solutions are built with HIPAA compliance at the core. We implement secure data encryption, access controls, audit logs, and follow all necessary safeguards to protect patient health information (PHI)."
                },
                {
                  question: "Can you help migrate patient data to a new system?",
                  answer: "Absolutely! We handle complete HIPAA-compliant data migration including cleaning, formatting, and securely transferring patient records to new systems. We ensure no data is lost and everything meets healthcare compliance standards."
                },
                {
                  question: "What ROI can I expect from medical practice automation?",
                  answer: "Most medical practices see significant administrative time savings within the first month. On average, our healthcare automation solutions save 15-25 hours per week in manual tasks. ROI depends on your specific workflows, but we provide detailed projections during consultation."
                }
              ].map((faq, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.4, delay: index * 0.1 }}
                >
                  <details className="group">
                    <summary className="flex items-center justify-between p-5 bg-[#19354a] rounded-lg cursor-pointer list-none">
                      <span className="font-semibold text-white">{faq.question}</span>
                      <span className="text-white text-2xl font-light group-open:hidden">+</span>
                      <span className="text-white text-2xl font-light hidden group-open:block">−</span>
                    </summary>
                    <div className="px-5 py-4 bg-gray-50 rounded-b-lg text-gray-700 leading-relaxed -mt-2">
                      {faq.answer}
                    </div>
                  </details>
                </motion.div>
              ))}
            </div>

          </div>
        </div>
      </section>

      {/*  CTA SECTION  */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <motion.h2 
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-3xl lg:text-4xl font-bold text-[#19354a] mb-6"
          >
            Ready to Automate Your Medical Practice?
          </motion.h2>
          <motion.p 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="text-gray-600 text-lg mb-8"
          >
            Let our healthcare automation experts build HIPAA-compliant systems that save time and scale your practice operations effortlessly.
          </motion.p>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="flex flex-col sm:flex-row gap-4 justify-center"
          >
            <Link 
              to="/contact" 
              className="px-8 py-4 bg-[#19354a] text-white rounded-lg font-semibold hover:bg-[#0f2133] transition-all"
            >
              Get a Free Consultation
            </Link>
            <a 
              href="tel:+918920845297" 
              className="px-8 py-4 border-2 border-[#19354a] text-[#19354a] rounded-lg font-semibold hover:bg-[#19354a] hover:text-white transition-all"
            >
              Call Us Now
            </a>
          </motion.div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default SystemsAutomationConsulting;